import PostsAll from './PostsAll';
import PostsAllContainer from './PostsAll.container';

export default PostsAllContainer(PostsAll);
